// extracted by mini-css-extract-plugin
module.exports = {"container":"InviteYou_container__7s1qO","anchor":"InviteYou_anchor__Wvr06","backgroundText":"InviteYou_backgroundText__Evzq7"};